import { colors } from "config/styles/themeColors";

const styles = {
  listWrap: {
    "&.MuiList-root": {
      pt: 0,
      pb: 0,
      mt: "-10px",
    },
    "& .MuiButtonBase-root": {
      height: "65px",
      borderBottom: "1px solid",
      borderBottomColor: "background.modalBg",
    },
  },
  itemBtn: {
    "&.MuiButtonBase-root.MuiListItemButton-root": {
      p: {
        xs: "0 16px",
        md: "0 36px",
      },
    },
  },
  time: (isOptions: boolean) => ({
    fontFamily: "sans-serif",
    fontWeight: isOptions ? 600 : 400,
    color: "text.primary",
    opacity: isOptions ? 1 : 0.3,
  }),
  innerList: {
    "& .MuiButtonBase-root": {
      height: "45px",
    },
    "& .MuiButtonBase-root.MuiListItemButton-root": {
      p: {
        xs: "0 26px",
        md: "0 46px",
      },
    },
    "& .MuiButtonBase-root.MuiListItemButton-root.Mui-disabled": {
      opacity: 1,
      "& .MuiListItemIcon-root": {
        opacity: 0.38,
      },
      "& .MuiListItemText-root": {
        opacity: 0.38,
      },
    },
    borderBottom: "1px solid",
    borderBottomColor: "background.modalBg",
  },
  innerItem: (isChecked: boolean) => ({
    pl: 4,
    backgroundColor: isChecked ? "green.itemHover" : "inherit",
    color: isChecked ? "green.main" : "gray.main",
    "&:hover": {
      backgroundColor: isChecked ? "green.itemHover" : "background.modalBg",
      color: isChecked ? "green.main" : "gray.main",
    },
    "& .MuiSvgIcon-root": {
      fill: isChecked ? colors.green.main : colors.gray.main,
      "&:hover": {
        fill: isChecked ? colors.green.main : colors.gray.main,
      },
    },
  }),
  innerEndIcon: (isChecked: boolean) => ({
    display: isChecked ? "inline-flex" : "none",
    justifyContent: "flex-end",
    minWidth: "40px",
  }),
  deleteIcon: (isChecked: boolean) => ({
    display: isChecked ? "none" : "inline-flex",
    justifyContent: "flex-end",
    minWidth: "40px",
  }),
  card: {
    opacity: 0.38,
  },
  addCard: {
    color: "gray.main",
    height: "45px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    width: "fit-content",
    ml: "auto",
    pr: {
      xs: "16px",
      md: "36px",
    },
  },
};

export default styles;
